import { Bug, Lightbulb, Sparkles } from "lucide-react";

export const TYPES = [
  { value: "issue", label: "Issue" },
  { value: "feature_request", label: "Feature request" },
  { value: "suggestion", label: "Suggestion" },
];
export const SEVERITIES = [
  { value: "low", label: "Low" },
  { value: "medium", label: "Medium" },
  { value: "high", label: "High" },
  { value: "critical", label: "Critical" },
];
export const STATUSES = [
  { value: "open", label: "Open" },
  { value: "in_progress", label: "In progress" },
  { value: "resolved", label: "Resolved" },
  { value: "rejected", label: "Rejected" },
];

const labelOf = (list, v) => list.find((x) => x.value === v)?.label || v || "—";
export const typeLabel = (v) => labelOf(TYPES, v);
export const severityLabel = (v) => labelOf(SEVERITIES, v);
export const statusLabel = (v) => labelOf(STATUSES, v);

// Colours and icons used by the redesigned page (tiles, pills, status buttons).
export const TYPE_META = {
  issue: { icon: Bug, color: "#F87171", tab: "Issues" },
  feature_request: { icon: Sparkles, color: "#A78BFA", tab: "Features" },
  suggestion: { icon: Lightbulb, color: "#FACC15", tab: "Suggestions" },
};
export const SEVERITY_COLOR = { critical: "#EF4444", high: "#FF8A1F", medium: "#FACC15", low: "#94A3B8" };
// Marks a request the employee deleted (admins still see all of it).
export const DELETED_COLOR = "#EF4444";

export const STATUS_COLOR = { open: "#FF8A1F", in_progress: "#38BDF8", resolved: "#22C55E", rejected: "#78746E" };

// Fired when unread state may have changed so the sidebar badge refreshes.
export const REQUESTS_CHANGED_EVENT = "employee-requests-changed";

export const formatSize = (bytes) =>
  bytes >= 1024 * 1024 ? `${(bytes / 1024 / 1024).toFixed(1)} MB` : `${Math.max(1, Math.round(bytes / 1024))} KB`;
